import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/VideoSection.css';

function VideoSectionAMZ() {
  const [isPlaying, setIsPlaying] = useState(false);

  // Remplacez par l'ID de votre playlist YouTube
  const PLAYLIST_ID = 'PLT0_3jl_6IHe_vty4IxtWun2g_s0JkzVw'; // À remplacer

  const handlePlayClick = () => {
    setIsPlaying(true);
    // Empêcher le scroll du body quand le lecteur est activé
    document.body.style.overflow = 'hidden';
  };

  const closePlayer = () => {
    setIsPlaying(false);
    // Réactiver le scroll du body
    document.body.style.overflow = 'unset';
  };

  return (
    <section className="video-section" style={{direction:'ltr'}}>
      <div className="container">
        <h2 className="video-title">ⵜⵓⴳⴳⴰ    </h2>

        <div className="playlist-container">
          <div className="playlist-preview">
            {/* Image de preview de la playlist */}
            <div className="playlist-thumbnail" onClick={handlePlayClick}>
              <img
                src="/images/tumb.jpg"
                alt="ⵜⴰⵏⴼⵓⵙⵜ ⵏ ⵜⵍⵉⵙⵜ"
              />
              <div className="play-button-large">
                <div className="play-icon"></div>
              </div>
              <div className="playlist-overlay">
                <div className="playlist-info">
                  <span className="playlist-badge">ⵜⴰⵍⵉⵙⵜ</span>
                  <h3 className="playlist-title">ⵜⵓⴳⴳⴰ ⵏ ⵜⵓⵏⴳⵉⵙⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ</h3>
                  <p className="playlist-description">
                  ⵜⴰⴳⵔⵓⵎⵎⴰ ⵏ ⵜⵓⴳⴳⴰ ⵜⵉⵏⵉⵍⴰⵡⵉⵏ ⵏ ⵓⴳⴳⵉⴷⵏ ⵉⵎⵏⴰⵍⴰⵏ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴷ ⵎⴰⵎⵏⴽ ⵙ ⵣⵔⵉⵏ ⵜⴰⵙⵙⴰⵙⵜ ⵏⵏⵙⵏ
                  </p>
                </div>
              </div>
            </div>

            {/* Liste des vidéos de la playlist */}
            <div className="playlist-videos-list">
              <div className="playlist-header">
                <h4 style={{textAlign:'left'}}>ⵜⵓⵎⴰⵢⵜ ⵏ ⵜⵍⴳⴰⵎⵜ</h4>
              </div>
              <div className="video-items">
                <div className="video-item" onClick={handlePlayClick}>
                  <div className="item-thumbnail">
                    <img src="/images/tumb.jpg" alt="ⵜⴰⴳⵉⵔⴰ 1" />
                    <div className="item-play-icon"></div>
                  </div>
                  <div className="item-info" style={{textAlign:'left'}}>
                    <h5 >ⵜⵓⴳⴳⴰ ⵏ ⵢⴰⵜ ⵜⵓⵏⴳⵉⵙⵜ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ</h5>
                    <p>ⵜⴰⵍⵍⴰⵙⵜ ⵜⴰⵏⵉⵍⴰⵡⵜ ⵏ ⵜⵎⵖⴰⵔⵜ ⵉⵎⵏⴰⵍⴰⵏ ⵜⴰⴷⴱⵔⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ</p>
                  </div>
                </div>




                <div className="video-item more-videos" onClick={handlePlayClick}>
                  <div className="more-indicator">
                    <span>+16</span>
                    <p>ⵓⴳⴳⴰⵔ ⵏ ⵜⵓⴳⴳⴰ</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="video-cta-container">

            <button className="cta-button">ⵥⵕ ⵜⵓⴳⴳⴰ ⴰⴽⴽⵯ</button>

        </div>
      </div>

      {/* Modal Lecteur Playlist */}
      {isPlaying && (
        <div className="video-modal-overlay" onClick={closePlayer}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="video-modal-close"
              onClick={closePlayer}
              aria-label="Fermer"
            >
              ×
            </button>
            <div className="video-player-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/videoseries?list=${PLAYLIST_ID}&autoplay=1&rel=0`}
                title="ⵜⴰⵍⵉⵙⵜ YouTube"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default VideoSectionAMZ;
